import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

const confettiShapeYellowTriangle = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAyNCAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjcyODUgMjcuNTg4OUwxNS42ODM2IDBMLTAuMDAwMjg2NTUxIDMyLjk3MjRMMjMuNzI4NSAyNy41ODg5WiIgZmlsbD0iI0ZGREY2RSIvPgo8L3N2Zz4K';
const confettiShapeRedRhombus = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyNiAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1LjEyNSAyMC44MDk4TDEzLjg1MzEgMjguMzE0NUwtMC4wMDE3MTUxMSA3LjUwNDc0TDE5LjExNzEgMTEuNzg2TDI1LjEyNSAyMC44MDk4WiIgZmlsbD0iI0NEMzk1QyIvPgo8L3N2Zz4K';
const confettiShapeSalmonHexagon = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMyAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNjAyNjggMjMuNjQ4N0wxNi40OTMgMzAuMTA4NEwyNi40MTQzIDI1Ljg5NTZMMzIuOTI1MiA5LjkyNDE5TDE2LjgwODggMy4yNzM4MUw3LjE1NTU2IDcuMzcyNjVMMC42MDI2OCAyMy42NDg3WiIgZmlsbD0iI0YxQjZCMCIvPgo8L3N2Zz4K';
const confettiShapeBlueRhombus = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyOCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3LjAyNiAxNy43NTEyTDcuMTE1NzYgMi4yMDk5M0wwLjg5OTI2NiAxMC4xNzRMMS45MjcyNCAxOC41MTU1TDI3LjAyNiAxNy43NTEyWiIgZmlsbD0iIzgwRDFDRCIvPgo8L3N2Zz4K';
const confettiShapePlumTriangle = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyOSAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNzAxMDEgMC4wMTU4Mzg0TDAuODMyMDMxIDI4LjQ5MjFMMjguNTY4NSA0Ljc0NjUyTDQuNzAxMDEgMC4wMTU4Mzg0WiIgZmlsbD0iIzk2MzQ4MSIvPgo8L3N2Zz4K';

export const ConfettiWrapper = styled.div`
  max-width: 100vw !important;

  @media screen and (min-width: ${layout.subLg}) {
    background:
      url(${confettiShapeYellowTriangle}) 4% 15% / 25px auto no-repeat,
      url(${confettiShapeRedRhombus}) 96% 12% / 25px auto no-repeat,
      url(${confettiShapeSalmonHexagon}) 9% 75% / 27px auto no-repeat,
      url(${confettiShapeBlueRhombus}) 87% 81% / 25px auto no-repeat,
      url(${confettiShapePlumTriangle}) 97% 92% / 25px auto no-repeat;
  }
`

export const CaseStudiesCarouselContainer = styled.div`
  padding: 0em 2em;
  position: relative;
  display: grid;
  max-width: 960px !important;
  grid-template-columns: 24px 1fr 24px;
  margin: 0 auto 4rem;

  @media all and (max-width: ${layout.sm}) {
    display: none;
  }
`

export const ChevronContainer = styled.div`
  align-self: center;
  justify-self: center;
  position: relative;
  cursor: pointer;
  transition: opacity ease-in-out 300ms;
`


export const CaseStudiesSliderContainer = styled.div`
  position: relative;
  overflow: hidden;
  display: grid;
`

export const CaseStudiesSlider = styled.div`
  display: flex;
  position: relative;
  transition: transform ease-in-out 250ms;
`


export const CaseStudy = styled.div`
  float: left;
  background: ${palette.white};
  box-shadow: 0px 0px 0.922676px rgba(0, 0, 0, 0.05), 0px 0.922676px 18.4535px rgba(0, 0, 0, 0.15);
  margin: 20px;
  align-self: start;
  overflow: hidden;
  display: grid;
  padding-bottom: 2rem;
  grid-template-rows: auto 1fr 46px;

  & > a {
    min-width: 256px;
  }

  @media all and (max-width: 531px) {
    width: 420px;
  }
`

export const CaseStudyTitle = styled.div`
  padding: 24px 40px;
  align-self: center;
  display: grid;
  row-gap: 1.5rem;

  p {
    margin: 0px;
    font-size: 1.125rem;
    font-weight: 300;
    text-align: center;
  }

  a {
    text-decoration: none;
    color: ${palette.text};
    
    &:hover {
      color: ${palette.snowFlower};
    }
  }
`

export const CaseStudyImage = styled.div`
  align-self: end;
  max-height: 474px;
  overflow: hidden;

  & > div {
    height: 100%;
  }
`
